import { InjectedStyledComponent } from '../InjectedStyledComponent';

export default InjectedStyledComponent('li', 'shared', ['listItem']);